<template lang="html">
   <section class="unifiedAgentDemo">
   
    <audio id="audio">
      <source>
    </audio>
      <table style="width:100%;height:80vh;border: solid 1px">
        <tr style="height:30%;border: solid 1px">
          <td style="background:#f9f4f4e0;width:20%;vertical-align: top">
            <section>
            <div style="width:100%;height:50px;background: black;display: flex;text-align:center;">
              <label style="width: 100%;color:white;font-size: 20px;margin-top:10px"><svg  class="Vlt-icon Vlt-white" style="width:30px;height:30px;margin-right: 5px"><use xlink:href="#V_Vlt-icon-user"></use></svg>Active Customer</label>
            </div>
            <div v-if="!isActiveCustomerHidden" style="width: 100%;margin-top: 2px;height: 60px;background: rgb(252, 252, 253);margin-left: 0.5%;margin-right: 0.5%;box-shadow: 4px 4px #888888;border-radius: 20px 0px 0px 20px"> 
              <table style="width:100%;height:100%">
                <tr>
                  <td style="text-align: left;vertical-align: middle;padding-left:10px;width:30%"><svg  class="Vlt-icon" style="width:40px;height:40px;"><use :xlink:href="'#icon-'+channel"></use></svg></td>
                  <td style="vertical-align: middle;text-align: left;"><label style="font-size: 20px"><b>{{callerName}}</b></label></td>
                </tr>
                <!--tr>
                  <td></td>
                  <td style="vertical-align: middle;"><label><button style="width:100px;" class="Vlt-btn Vlt-btn--app Vlt-btn--primary" v-on:click="endActiveSession()"> End Session</button></label></label></td>
                </tr-->
              </table>
             
            </div>
            </section>
          </td>
          <td rowspan="2" style="width:55%;border: solid 1px" class="middlearea">
                  
                 <div v-if="!isVideoCallHidden" class="Vlt-card" style="height: 100%;width:100%;text-align:left;">
                      <div id="subscriber" style="width:100%;height:90%;background:#f7f5f1;position:relative;border: solid 2px">
                                        
                      </div>
                     <div id="publisher" style="width:30%;height:30%;background:#efecec;z-index:100;right:0px;bottom:70px;position:absolute;border:solid 1px">
                        
                    </div>
                    <div style="vertical-align:middle;text-align: center;width:100%;height:10%;background:black;z-index:101;position:inherit">
                      <button v-on:click="joinVideoSession()" v-if="!isVideoAcceptBtnHidden" style="background: black;padding:5px"><svg data-v-497a0e1c="" class="Vlt-icon Vlt-green" style="width:50px;height:50px"><use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-phone"></use></svg></button>
                         <button v-on:click="closeVideoSession()" v-if="!isVideoHangupBtnHidden" style="background: black;padding:5px"><svg data-v-497a0e1c="" class="Vlt-icon Vlt-red" style="width:50px;height:50px"><use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-phone-down"></use></svg></button>
                        <button v-on:click="muteVideoMic()" v-if="!isVideoMiconBtnHidden" style="background: black;padding:5px"><svg data-v-497a0e1c="" class="Vlt-icon Vlt-green" style="width:50px;height:50px"><use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-microphone"></use></svg></button>
                        <button v-on:click="unmuteVideoMic()" v-if="!isVideoMicoffBtnHidden" style="background: black;padding:5px"><svg data-v-497a0e1c="" class="Vlt-icon Vlt-red" style="width:50px;height:50px"><use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-microphone-mute"></use></svg></button>
                    </div>  
                </div>
                <div v-if="!isCallWindowHidden" class="Vlt-card" style="width:400px;height:230px;background: floralwhite;margin: 200px auto auto auto">
                  <div style="margin-top:50px;text-align: center;">

                    <div style="height:50px">
                      <label id="from" style="font-size: 40px;line-height: normal"> {{callerName}} </label>
                    </div>
                     <div class="Vlt-badge Vlt-badge--app Vlt-badge--purple Vlt-badge--transparent" style="height:40px;font-size: 38px"> 
                      {{timerValue}} 
                    </div>
                    <div style="height:25px">
                      <label id="from" style="font-size: 30px;line-height: normal"> {{callState}} </label>
                    </div>
                    <div style="padding:40px">
                        <button v-if="!callAnswered"  v-on:click="joinCall()"><svg  class="Vlt-icon Vlt-green" style="width:50px;height:50px;"><use xlink:href="#V_Vlt-icon-call"></use></svg></button>
                        <button v-if="callAnswered && !callOnHold" v-on:click="holdVoiceCall()"><svg  class="Vlt-icon Vlt-green" style="width:50px;height:50px;"><use xlink:href="#V_Vlt-icon-call-pause"></use></svg></button>
                        <button v-if="callAnswered && callOnHold" v-on:click="resumeVoiceCall()"><svg  class="Vlt-icon Vlt-red" style="width:50px;height:50px;"><use xlink:href="#V_Vlt-icon-call-pause"></use></svg></button>
                        <button v-if="callAnswered" v-on:click="showSupervisorPanel()"><svg  class="Vlt-icon Vlt-green" style="width:50px;height:50px;"><use xlink:href="#V_Vlt-icon-phone-plus"></use></svg></button>
                        <button v-if="callAnswered && !voiceCallMuted" v-on:click="muteVoiceCall()"><svg  class="Vlt-icon Vlt-green" style="width:50px;height:50px;"><use xlink:href="#V_Vlt-icon-microphone"></use></svg></button>
                        <button v-if="callAnswered && voiceCallMuted" v-on:click="unmuteVoiceCall()"><svg  class="Vlt-icon Vlt-red" style="width:50px;height:50px;"><use xlink:href="#V_Vlt-icon-microphone-mute"></use></svg></button>
                        <button v-on:click="hangUpOrRejectCall()"><svg  class="Vlt-icon Vlt-red" style="width:50px;height:50px;"><use xlink:href="#V_Vlt-icon-phone-down" ></use></svg></button>
                    </div>
                    <!--button  v-on:click="joinCall()" class="Vlt-btn Vlt-btn--primary Vlt-btn--app">Call</button-->
                  </div>
              </div>
              <div v-if="!isCallWindowHidden && !isSupervisorPanelHidden" class="Vlt-card" style="width:400px;height:60px;background: floralwhite;margin: 5px auto auto auto">
                  <div style="padding-top:5px">
                       <table style="margin-top:5px">
                    <tr>
                      <td style="width: 2%">
                      </td>
                      <td style="width:60%">
                        <vlt-field >
                        <vue-phone-number-input :default-country-code="nexmo.region" v-model="prettyNumber" @update="onSupervisorNumberUpdate" />
                        </vlt-field>
                      </td>
                      <td style="vertical-align: bottom"> <button v-on:click.prevent="addSupervisor()" class="Vlt-btn Vlt-btn--app Vlt-btn--primary" style="padding-right:10px;padding-left:10px;height: 42px">Invite</button><button v-on:click.prevent="cancelSupervisorCall()" class="Vlt-btn Vlt-btn--app Vlt-btn--primary" style="padding-right:10px;padding-left:10px;height: 42px">Cancel</button></td>
                    </tr>
                  </table>
                    
                  </div>
              </div>
              <div v-if="!isChatWindowHidden" class="Vlt-card Vlt-article" style="width:100%">
                 <div class="Vlt-grid">
                    <div class="Vlt-col">
                        <section class="msger">
                          <header class="msger-header">
                            <div>
                              <button v-on:click="endActiveSession()" class="Vlt-btn Vlt-btn--app Vlt-btn--primary" style="padding-right:30px;padding-left:30px;height: 42px">End Session</button>
                            </div>
                          </header>
                          <main id="msger-chat" class="msger-chat middlearea" v-html="chatContent">
                          </main>
                          <form class="msger-inputarea">
                            <button  v-on:click.prevent="showAttachmentDialog($event)"><svg  class="Vlt-icon " style="width:50px;height:50px;margin-right: 5px"><use xlink:href="#V_Vlt-icon-attachment"></use></svg></button>
                            &nbsp;&nbsp;
                            <input type="text" class="msger-input" placeholder="Enter your message..." v-on:keyup.enter="sendAgentMessage()">
                            <button type="submit" class="msger-send-btn" v-on:click.prevent="sendAgentMessage()">Send</button>
                          </form>
                        </section>
                    </div> 
                 </div>
              </div>
          </td>
          <td rowspan="2" style="background:#f9f4f4e0;border: solid 1px;vertical-align: top">
             <div style="width:100%;height:50px;background: black;display: flex;text-align: center;">
              <label style="width: 100%;color:white;font-size: 20px;margin-top:10px"><svg  class="Vlt-icon Vlt-white" style="width:30px;height:30px;margin-right: 5px"><use xlink:href="#V_Vlt-icon-chat"></use></svg>Channels</label>
            </div>
            <div style="margin-top: 50px;width:100%">
              <vlt-tabs >
                <vlt-tab label="WhatsApp" >
                  <div style="text-align: center;">
                     <label>If you are the account owner, scan and start conversation</label>
                  </div>
                  <div style="padding-top:20px;text-align: center;">
                    <img :src="server+'/unifiedAgent/images/wa-qr.png'" style="width:50%"/>
                  </div>
                  <div style="margin-top: 20px;margin-bottom: 20px;text-align: center;">
                    <label style="font-size: 20px"><b>-OR-</b></label>
                  </div>
                  <div style="text-align: center;">
                  <table style="width: 100%">
                    <tr>
                      <td style="width: 2%">
                      </td>
                      <td style="width:80%">
                        <vlt-field label="Invite external users to try it">
                        <vue-phone-number-input :default-country-code="nexmo.region" v-model="prettyNumber" @update="onWAInviteNumberUpdate" />
                        </vlt-field>
                      </td>
                      <td style="vertical-align: bottom"> <button v-on:click.prevent="sendWAInvite()" class="Vlt-btn Vlt-btn--app Vlt-btn--primary" style="padding-right:10px;padding-left:10px;height: 42px">Invite</button></td>
                    </tr>
                  </table>
                  </div>
                </vlt-tab>
                <vlt-tab label="PSTN" >
                  <div style="margin-top: 50px;text-align: center;">
                  <label style="font-size: 30px"> <b>Call {{prettyNumber}}</b></label>
                </div>
                </vlt-tab>
                <vlt-tab label="In-App" >
                  <div style="text-align: center;">
                     <label>Scan to start a conversation</label>
                  </div>
                  <div style="padding-top:20px;text-align: center;">
                  <img  :src="'https://chart.googleapis.com/chart?cht=qr&choe=UTF-8&chs=150x150&chl=https://nids.nexmo.com/unifiedAgent/inapp?uid='+nexmo['userid']"/><br/>
                </div>
                <div style="margin-top: 20px;margin-bottom: 20px;text-align: center;">
                    <label style="font-size: 20px"><b>-OR-</b></label>
                  </div>
                <div style="text-align: center;">
                    <label> Open this URL in a Browser</label><br/><br/>
                    <label style="font-size: 14px; "><b>https://nids.nexmo.com/unifiedAgent/inapp?uid={{nexmo['userid']}}</b></label>
                  </div>
                       
                </vlt-tab>
                <vlt-tab label="Video" >
                  <div style="text-align: center;">
                     <label>Scan to start a Video call</label>
                  </div>
                   <div style="padding-top:20px;text-align: center;">
                  <img  :src="'https://chart.googleapis.com/chart?cht=qr&choe=UTF-8&chs=150x150&chl=https://nids.nexmo.com/unifiedAgent/v?uid='+nexmo['userid']"/><br/>
                   </div>
                   <div style="margin-top: 20px;margin-bottom: 20px;text-align: center;">
                    <label style="font-size: 20px"><b>-OR-</b></label>
                  </div>
                  <div style="text-align: center;">
                    <label> Open this URL in a Browser</label><br/><br/>
                    <label style="font-size: 14px; "><b>https://nids.nexmo.com/unifiedAgent/v?uid={{nexmo['userid']}}</b></label>
                  </div>
                </vlt-tab>
               
                <vlt-tab label="Viber" >
                  <div style="text-align: center;">
                     <label>If you are the account owner, Open Viber -> More and scan QR</label>
                  </div>
                  <div style="padding-top:20px;text-align: center;">
                    <img :src="server+'/unifiedAgent/images/viber-qr.png'" style="width:50%"/>
                  </div>
                  <div style="margin-top: 20px;margin-bottom: 20px;text-align: center;">
                    <label style="font-size: 20px"><b>-OR-</b></label>
                  </div>
                  <div style="text-align: center;">
                  <table style="width: 100%">
                    <tr>
                      <td style="width: 2%">
                      </td>
                      <td style="width:80%">
                        <vlt-field label="Invite external users to try it">
                        <vue-phone-number-input :default-country-code="nexmo.region" v-model="prettyNumber" @update="onViberInviteNumberUpdate" />
                        </vlt-field>
                      </td>
                      <td style="vertical-align: bottom"> <button v-on:click.prevent="sendViberInvite()" class="Vlt-btn Vlt-btn--app Vlt-btn--primary" style="padding-right:10px;padding-left:10px;height: 42px">Invite</button></td>
                    </tr>
                  </table>
                  </div>
                </vlt-tab>
                  <vlt-tab label="Messenger" >
                 <div style="text-align: center;">
                     <label>Coming soon</label>
                  </div>
                </vlt-tab>
              </vlt-tabs>
            </div>
          </td>
        </tr>
        <tr>
          <td  style="background:#f9f4f4e0;border: solid 1px">
            <div style="width:100%;height:50px;background: black;display: flex;text-align:center;">
              <label style="width: 100%;color:white;font-size: 20px;margin-top:10px"><svg  class="Vlt-icon Vlt-white" style="width:30px;height:30px;margin-right: 5px"><use xlink:href="#V_Vlt-icon-queue"></use></svg>Queue</label>
            </div>
            <div v-html="queueItems">
            </div>
            
          </td>
        </tr>
      </table>
      <div v-if="!isAttachmentDialogHidden" :style="'border: black solid 1px; border-radius: 10px;position: absolute;z-index: 5;left:'+attachmentDialogLeft+';top:'+attachmentDialogTop">
             <div class="Vlt-card" style="text-align: left;height:300px;background: floralwhite">
                    
                    <div style="text-align:right"><svg  v-on:click="closeUploadPage()" class="Vlt-icon" style="width:30px;height:30px;padding:2px"><use xlink:href="#V_Vlt-icon-cross-circle"></use></svg></div>
                    <label style="font-size:20px;padding:60px"><b>Upload Media</b></label><br/><br/>
                    <input style="margin-left:60px" id="mediafile" name="mediafile" type="file" ref="file" v-on:change="handleFileUpload()"/>
                    <button  style="margin-right:30px;padding:10px" v-on:click="submitFile()" class="Vlt-btn Vlt-btn--primary Vlt-btn--app">{{uploadLabel}}</button>
                    <!--svg   class="Vlt-icon Vlt-green" style="width:45px;height:45px"><use data-v-497a0e1c="" xlink:href="#V_Vlt-icon-check-circle-negative"></use></svg-->
              </div>
      </div>
       <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
        <symbol viewBox="0 0 24 24" id="icon-whatsapp"><path d="M11.997.595a11.235 11.235 0 0 1 7.997 3.315 11.234 11.234 0 0 1 3.308 7.996c-.002 6.232-5.074 11.302-11.305 11.302h-.005c-1.892 0-3.752-.475-5.403-1.376L.596 23.404 2.2 17.547a11.279 11.279 0 0 1-1.51-5.65C.693 5.665 5.764.595 11.997.595zm0-.595C5.437 0 .097 5.337.095 11.897c0 2.005.505 3.98 1.465 5.73l-1.539 5.62a.594.594 0 0 0 .726.733l5.768-1.512a11.925 11.925 0 0 0 5.477 1.336c6.564 0 11.903-5.337 11.906-11.897a11.824 11.824 0 0 0-3.482-8.418A11.831 11.831 0 0 0 11.996 0z" fill="#CFD8DC"></path><path d="M18.643 5.26A9.333 9.333 0 0 0 12 2.504c-5.183 0-9.399 4.213-9.401 9.393 0 1.775.496 3.503 1.437 5l.224.355-.95 3.466 3.557-.933.343.204a9.379 9.379 0 0 0 4.783 1.31h.004c5.18 0 9.395-4.215 9.396-9.395 0-2.51-.975-4.87-2.75-6.646z" fill="#40C351"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M9.17 7.172c-.21-.47-.434-.48-.635-.488-.165-.007-.354-.006-.542-.006-.188 0-.494.07-.753.353s-.99.966-.99 2.356 1.013 2.733 1.154 2.921c.141.188 1.955 3.132 4.826 4.265 2.386.94 2.872.753 3.39.706.518-.047 1.672-.683 1.907-1.342.235-.66.235-1.225.165-1.343-.071-.118-.26-.188-.541-.33-.283-.142-1.672-.825-1.931-.919-.26-.094-.447-.141-.636.142-.188.282-.73.919-.894 1.107-.165.189-.33.212-.613.07-.282-.141-1.192-.439-2.271-1.401-.84-.749-1.407-1.673-1.572-1.956-.165-.283-.018-.436.124-.577.127-.127.282-.33.424-.495.141-.165.188-.282.282-.47.094-.19.047-.354-.024-.495-.07-.142-.618-1.54-.87-2.098z" fill="#fff"></path></symbol>
        <symbol viewBox="0 0 24 24" fill="none" id="icon-viber"><g clip-path="url(#clip0)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3.41 2.466C5.85.236 9.856 0 12.428 0 15 0 19.007.237 21.448 2.466c1.725 1.718 2.409 4.128 2.409 7.248v.194l-.001.663.001.663v.194c0 3.12-.684 5.53-2.41 7.248-2.441 2.23-6.447 2.467-9.019 2.467-.577 0-1.23-.016-1.919-.06-1.155 1.295-2.217 2.479-2.31 2.56-.244.218-.488.356-.77.357h-.005c-.11 0-.71-.017-.71-.929v-2.62c-1.217-.368-2.375-.926-3.305-1.775C1.684 16.958 1 14.547 1 11.428v-.194l.001-.663a77.412 77.412 0 0 1 0-.663v-.194c0-3.12.683-5.53 2.408-7.248zm18.733 8.962v-.199c0-.2 0-.417-.002-.646.002-.203.002-.383.002-.55v-.319c0-2.803-.597-4.713-1.878-6.007-2.218-1.993-6.444-1.993-7.836-1.993-1.393 0-5.619 0-7.837 1.993-1.28 1.294-1.877 3.204-1.877 6.007v.2 1.514c0 2.803.597 4.714 1.877 6.007.875.786 2.063 1.26 3.265 1.548v3.35s2.422-2.708 2.647-2.962c.812.057 1.5.058 1.924.058 1.393 0 5.62 0 7.837-1.994 1.281-1.293 1.878-3.204 1.878-6.007zm-4.314 2.774c-.582-.49-.877-.667-1.599-1.1l-.205-.123c-.365-.218-.922-.408-1.214-.408-.2 0-.438.153-.584.3-.1.099-.182.205-.26.308-.219.283-.413.535-.895.535-.643 0-1.766-.654-2.572-1.5C9.655 11.41 9 10.286 9 9.643c0-.487.253-.685.536-.908.1-.078.202-.159.3-.256.146-.146.307-.385.307-.584 0-.292-.189-.84-.408-1.205l-.125-.21c-.43-.72-.607-1.014-1.098-1.595-.18-.215-.387-.313-.603-.314-.365 0-.845.181-1.17.423-.487.364-.998.86-1.134 1.476-.018.084-.03.169-.033.253-.026.643.227 1.296.5 1.848.64 1.303 1.49 2.563 2.414 3.689.295.36.617.695.95 1.018.324.333.659.655 1.019.95 1.125.925 2.386 1.774 3.688 2.415.548.27 1.192.518 1.829.5.09-.003.181-.013.272-.033.617-.136 1.113-.647 1.477-1.135.242-.325.423-.804.422-1.17 0-.215-.099-.422-.314-.603zm.314-2.773a.572.572 0 0 1-.571-.572v-.571a5.15 5.15 0 0 0-5.143-5.143.572.572 0 0 1 0-1.143 6.293 6.293 0 0 1 6.286 6.286v.571a.572.572 0 0 1-.572.572zm-3.51-1.143a.571.571 0 0 1-.552-.428 1.708 1.708 0 0 0-1.224-1.224.572.572 0 0 1 .287-1.107 2.854 2.854 0 0 1 2.043 2.043.572.572 0 0 1-.554.716zm1.796.571a.572.572 0 0 1-.572-.571 3.425 3.425 0 0 0-3.244-3.42.571.571 0 1 1 .06-1.142A4.567 4.567 0 0 1 17 10.286a.572.572 0 0 1-.571.571z" fill="#7E57C2"></path></g></symbol>
        <symbol viewBox="0 0 24 24" fill="none" id="icon-facebook"><path d="M24 12c0-6.628-5.372-12-12-12S0 5.372 0 12c0 5.99 4.388 10.955 10.125 11.855v-8.386H7.078V12h3.047V9.356c0-3.007 1.79-4.668 4.533-4.668 1.312 0 2.686.234 2.686.234v2.953H15.83c-1.49 0-1.955.926-1.955 1.875V12h3.328l-.532 3.469h-2.796v8.386C19.613 22.955 24 17.99 24 12z" fill="#1877F2"></path><path d="M16.671 15.469L17.203 12h-3.328V9.75c0-.95.464-1.875 1.955-1.875h1.514V4.922s-1.374-.234-2.686-.234c-2.742 0-4.533 1.661-4.533 4.668V12H7.078v3.469h3.047v8.386a12.071 12.071 0 0 0 3.75 0v-8.386h2.796z" fill="#fff"></path></symbol>
        <symbol viewBox="0 0 16 16" id="icon-video"><path d="M15.8 4.1c-.2-.1-.3-.1-.5-.1L11 5.8V3.5c0-.8-.7-1.5-1.5-1.5h-8C.7 2 0 2.7 0 3.5v9c0 .8.7 1.5 1.5 1.5h8c.8 0 1.5-.7 1.5-1.5v-2.3l4.3 1.7c.2.1.3 0 .5-.1.1-.1.2-.2.2-.4v-7c0-.1-.1-.2-.2-.3zM10 6.5v6c0 .3-.2.5-.5.5h-8c-.3 0-.5-.2-.5-.5v-9c0-.3.2-.5.5-.5h8c.3 0 .5.2.5.5v3zm5 4.3l-4-1.6V6.8l4-1.6v5.6z"></path></symbol>
        <symbol viewBox="0 0 24 24" id="icon-pstn"><path d="M20.76 12.766h3.191C23.951 5.745 18.206 0 11.185 0v3.192c5.266 0 9.574 4.308 9.574 9.574zm-6.384 0h3.192c0-3.51-2.873-6.383-6.383-6.383v3.192a3.201 3.201 0 0 1 3.191 3.191zm4.15 3.99c1.117.797 1.915 1.276 2.234 1.436.08.08.16.15.24.22.239.209.478.418.717.897.16.319.32.798.16 1.117l-.479 1.117c-.319.957-1.117 1.596-2.074 2.075-.958.478-2.075.478-3.192.159-1.117-.16-2.234-.638-3.51-1.277-1.277-.638-2.395-1.436-3.512-2.234s-2.074-1.595-2.872-2.393C5.44 17.075 4.642 16.117 3.844 15c-.786-.917-1.357-1.942-1.89-2.898-.115-.208-.23-.413-.344-.613C.972 10.213.493 9.096.174 7.98c-.32-1.117-.16-2.235.16-3.192.478-.957 1.276-1.755 2.234-2.075l1.117-.478c.319 0 .798 0 1.117.16.355.118.534.324.734.553.069.08.14.162.223.244.16.32.639 1.117 1.436 2.234l.958 1.915c.16.639.16 1.277 0 1.756-.16.638-.479 1.436-1.117 1.755v.32c0 .478.32.957.957 1.755.639.797 1.117 1.276 1.596 1.595.32.32.798.798 1.596 1.437.798.638 1.277.798 1.755.957h.32c.319-.479.957-.957 1.755-1.117.957-.32 2.234.16 3.51.958z"></path></symbol>
        <symbol viewBox="0 0 24 24" id="icon-inapp-chat"><path d="M16.5 0h-15A1.5 1.5 0 0 0 0 1.5V12a1.5 1.5 0 0 0 1.5 1.5h3V18L9 13.5h7.5A1.5 1.5 0 0 0 18 12V1.5A1.5 1.5 0 0 0 16.5 0zM21 6h1.5A1.5 1.5 0 0 1 24 7.5V18a1.5 1.5 0 0 1-1.5 1.5h-3V24L15 19.5H7.5l2.742-3H19.5A1.5 1.5 0 0 0 21 15V6z"></path></symbol>
    </svg>
   </section>
</template>
<script lang="js">
import OT from "@opentok/client";
import NexmoClient from 'nexmo-client';
import {
    $NODEBASE
} from '../base';
import {
    $HTTPDEMO,
    requestHandler
} from '../services/nidsService.js';
import Pusher from "pusher-js";
import {
    parsePhoneNumberFromString
} from 'libphonenumber-js';
import {
    VltIcon,
    VltButton,
    VltCard,
    VltTab,
    VltTabs,
    VltGrid,
    VltCol,
    VltField,
    VltInput,
    VltBadge,

} from "@vonagevolta/vue";
import axios from 'axios';

export default {
    name: 'unifiedAgentDemo',
    data() {
        return {
            DEMO: {},
            server:'https://vids.vonage.com',
            message: {},
            channel:'',
            callerName: '',
            callState: '',
            callOnHold:false,
            timerValue:"00:00",
            uploadBaseUrl:'',
            attachmentDialogTop:"0px",
            attachmentDialogLeft:"0px",
            isActiveCustomerHidden: true,
            isAttachmentDialogHidden: true,
            isChatWindowHidden: true,
            isCallWindowHidden: true,
            isVideoCallHidden: true,
            isVideoMicoffBtnHidden: true,
            isVideoMiconBtnHidden: true,
            isVideoHangupBtnHidden:true,
            isVideoAcceptBtnHidden: true,
            isSupervisorPanelHidden: true,
            isAgentBusy:false,
            callAnswered:false,
            voiceCallMuted:false,
            number: '',
            file:'',
            supervisorNumber:'',
            viberInviteNumber:'',
            viberImageFormats:['jpg','jpeg', 'png'],
            waInviteNumber:'',
            waImageFormats:['jpg','jpeg', 'png'],
            waAudioFormats:['aac', 'm4a', 'amr', 'mp3','opus'],
            waFileFormats:['pdf','doc','docx','ppt','pptx','xls','xlsx'],
            waVideoFormats:['mp4','3gpp'],
            prettyNumber: '',
            numberStuff: {},
            incoming: [],
            delivery: [],
            /*queue:[{"from":"6584663190","channel":"pstn"},{"from":"6584663190","channel":"whatsapp"},{"from":"6584663190","channel":"viber"},{"from":"6584663190","channel":"video"},{"from":"6584663190","channel":"inapp-chat"}],*/
            queue:[],
            fromNumber: '',
            uploadedFile:'',
            pusherChannel:null,
            chatContent:'',
            nexmoClient:null,
            caller_uuid:'',
            inapp:null,
            audioElem:null,
            activeCall:null,
            queueItems:'',
            subscriber:null,
            publisher:null,
            session:null,
            token:'',
            sessionId:'',
            apiKey:'',
            inappchatconv:null,
            elapsed_seconds:0,
            uploadLabel: 'Send',
            DC:'',
         }
    },
    props: {
        nexmo: {
            type: Object,
            required: false
        }
    },
    methods: {
        sendWAMessage(msgText){
           this.DEMO.post('unifiedAgent/sendwatext', {
                  to: this.callerName,
                  message: msgText
            });
        },
        sendViberMessage(msgText){
           this.DEMO.post('unifiedAgent/sendvibertext', {
                  to: this.callerName,
                  message: msgText
            });
        },
        showSupervisorPanel(){
          //this.isSupervisorPanelHidden = false;
          alert('not implemented yet');
        },
        cancelSupervisorCall(){
          this.isSupervisorPanelHidden = true;
        },
        holdVoiceCall(){
          this.DEMO.post('unifiedAgent/starthold', {
                caller_uuid: this.caller_uuid
            });
          this.muteVoiceCall();
          this.callOnHold = true;
          this.callState = "On Hold";
        },
        resumeVoiceCall(){
          this.DEMO.post('unifiedAgent/stophold', {
                caller_uuid: this.caller_uuid
            });
          this.unmuteVoiceCall();
          this.callOnHold=false;
          this.callState = "Connected";
        },
        muteVoiceCall(){
          this.activeCall.conversation.me.mute(true);
          this.voiceCallMuted = true;
        },
        unmuteVoiceCall(){
          this.activeCall.conversation.me.mute(false);
          this.voiceCallMuted = false;
        },
        joinVideoSession(){
            this.isVideoHangupBtnHidden = false;
            this.isVideoAcceptBtnHidden = true;
            this.isVideoMiconBtnHidden = true;
            this.isVideoMicoffBtnHidden = false;
            this.session = OT.initSession(this.apiKey, this.sessionId);
            this.session.connect(this.token, err => {
                if (err) {
                    errorHandler(err);
                }
                else{
                    var elem = document.getElementById("publisher");
                    this.publisher = OT.initPublisher(elem, {
                                            insertMode: 'append',
                                            width: '100%',
                                            height: '100%'
                                        }, err => {
                        if (err) {
                            this.$emit("error", err);
                        } else {
                            this.$emit("publisherCompleted");
                            this.session.publish(this.publisher, err => {
                                if (err) {
                                    this.$emit("error", err);
                                } else {
                                    this.$emit("publisherConnected", this.publisher);
                                    this.isVideoHangupBtnHidden = false;
                                    this.isVideoMicoffBtnHidden = true;
                                    this.isVideoMiconBtnHidden = false;
                                }
                            });
                        }
                    });
                }
            });
            this.session.on("streamCreated", event => {
                this.subscriber = this.session.subscribe(event.stream,
                                        'subscriber',
                                        {
                                            insertMode: 'append',
                                            width: '100%',
                                            height: '100%'
                                        },
                                        function (error) {
                                            if (error) {
                                                console.log(error);
                                            } else {
                                                console.log('Subscriber added.');
                                                
                                            }
                                });
                this.isResultHidden = false;
            });
            this.session.on("streamDestroyed", event => {
                
            });

        },
        closeVideoSession(){
            this.session.disconnect();
            this.session = null;
            this.isVideoHangupBtnHidden = true;
            this.isVideoAcceptBtnHidden = true;
            this.isVideoMicoffBtnHidden = true;
            this.isVideoMiconBtnHidden = true;
            this.isVideoCallHidden = true;
            this.endActiveSession();
        },
        muteVideoMic(){
            this.publisher.publishAudio(false);
            this.isVideoMicoffBtnHidden = false;
            this.isVideoMiconBtnHidden = true;
        },
        unmuteVideoMic(){
            this.publisher.publishAudio(true);
            this.isVideoMicoffBtnHidden = true;
            this.isVideoMiconBtnHidden = false;
        },
        closeUploadPage(){
          this.isAttachmentDialogHidden=true;
        },
        sendWAInvite(){
          this.DEMO.post('unifiedAgent/sendwainvite', {
                to: this.waInviteNumber
            });
          this.$swal('Success',
                'Invitation sent successfully',
                'success');
        },
        sendViberInvite(){
          this.DEMO.post('unifiedAgent/sendviberinvite', {
                to: this.viberInviteNumber
            });
          this.$swal('Success',
                'Invitation sent successfully',
                'success');
        },
        onWAInviteNumberUpdate(payload) {
            this.waInviteNumber = payload;
            if (payload.isValid) {
                this.waInviteNumber = this.waInviteNumber.formattedNumber.replace(/\D/g, '');
            }
        },
        onViberInviteNumberUpdate(payload) {
            this.viberInviteNumber = payload;
            if (payload.isValid) {
                this.viberInviteNumber = this.viberInviteNumber.formattedNumber.replace(/\D/g, '');
            }
        },
        onSupervisorNumberUpdate(payload){
            this.supervisorNumber = payload;
            if (payload.isValid) {
                this.supervisorNumber = this.supervisorNumber.formattedNumber.replace(/\D/g, '');
            }
        },
        endActiveSession(){
          /*check queue*/
          if(this.channel == "inapp-chat"){
            this.sendInAppChat("Your Session has ended");
            this.inappchatconv.off("text");
            this.inappchatconv.off("member:media");
            this.inappchatconv.off("image");
          }
          else if(this.channel=="whatsapp"){
            this.sendWAMessage("Your Session has ended");
          }
          else if(this.channel=="viber"){
            this.sendViberMessage("Your Session has ended");
          }
          this.callerName="-none-";
          this.channel="-none-";
          this.chatContent='';
          this.isChatWindowHidden = true;
          this.isCallWindowHidden = true;
          this.isVideoCallHidden = true;
          if(this.queue.length > 0){
              var entry = this.queue.shift();
              this.isActiveCustomerHidden = false;
              this.callerName = entry.from;
              this.channel = entry.channel;
              if(entry.channel=="whatsapp" || entry.channel =="viber"){
                this.isChatWindowHidden = false;
                this.sendCustomerMessage(entry.message);
              }
              else if(entry.channel=="pstn"){
                this.isCallWindowHidden = false;
                this.caller_uuid = entry.caller_uuid
                this.callState="Ringing";
                this.timerValue="00:00";
                clearInterval(this.callTimer);
              }
              else if(entry.channel=="inapp-chat"){
                this.isChatWindowHidden = false;
                this.joinInAppSession(entry.conversationid);
              }
              else if(entry.channel=="video"){
                this.isVideoCallHidden = false;
                this.apiKey = entry.apiKey;
                this.token = entry.token;
                this.sessionId = entry.sessionId;
                this.isVideoAcceptBtnHidden = false;
                setTimeout(function(){document.getElementById('subscriber').innerHTML = '<label style="font-size:20px;margin-left:20%;margin-top:150px;position: absolute;">To Accept the Video call, please click on the Phone icon below</label>';},1000);
              }
              this.updateQueue();
          }
          else{
            this.isAgentBusy = false;
            this.isActiveCustomerHidden = true;
            this.channel='';
          }
        },
        joinCall(){
            this.callState="Connecting..";
            this.voiceCallMuted=false;
            this.DEMO.post('unifiedAgent/bridgecall', {
                app_user: this.owner,
                caller_uuid: this.caller_uuid
            });
        },
        addSupervisor(){
            this.DEMO.post('unifiedAgent/addsupervisor', {
                userId: this.inapp.me.id,
                supervisorNumber: this.supervisorNumber,
                conversationid: this.activeCall.conversation.id
            });
        },
        hangUpOrRejectCall(){
          if(this.activeCall){
            this.activeCall.hangUp();
            this.callAnswered = false;
            this.isCallWindowHidden = true;
            this.isActiveCustomerHidden = true;
            this.activeCall = null;
            this.endActiveSession();
          }
          else{
            this.DEMO.post('unifiedAgent/rejectcall', {
                caller_uuid: this.caller_uuid
            });
            this.callAnswered = false;
            this.isCallWindowHidden = true;
            this.isActiveCustomerHidden = true;
            this.activeCall = null;
            this.endActiveSession();
          }
          clearInterval(self.callTimer);
          self.timerValue="00:00";
        },
        handleFileUpload(){
            this.file = this.$refs.file.files[0];
        },
        makeid(length) {
           var result           = '';
           var characters       = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
           var charactersLength = characters.length;
           for ( var i = 0; i < length; i++ ) {
              result += characters.charAt(Math.floor(Math.random() * charactersLength));
           }
           return result;
        },
        sendImageInApp(){
          this.inappchatconv.sendImage(this.file).then((imageRequest) => {
           imageRequest.onabort = (e) => {
             console.log(e);
             console.log("Image:" + e.type);
           };
           imageRequest.onloadend = (e) => {
             console.log("Image:" + e.type);
           };
          });
        },
        async submitFile(){
            this.uploadLabel ="Wait..";
            if(this.channel=="inapp-chat"){
              if(!this.hasExtension("mediafile",['.jpg','.png','.jpeg'])){
                  this.uploadLabel="Send";
                  alert("you can only send images - jpg/jpeg/png");
                  return;
              }
              else{
                this.sendImageInApp();
                this.isAttachmentDialogHidden = true;
                this.uploadLabel="Send";
              }
              return;
            }
            try{
                let formData = new FormData();
                formData.append('mediafile', this.file);
                let res = await this.DEMO.post( '/unifiedAgent/upload-media',
                            formData,
                            {
                                headers: {
                                    'Content-Type': 'multipart/form-data'
                                }
                
                            }
                );
                console.log(res.data);
                this.isAttachmentDialogHidden = true;
                this.uploadLabel='Send';
                if(res.data.status != "success"){
                    alert("Error uploading the file");
                }
                else{
                    this.uploadedFile = res.data.filename;
                    let extension = res.data.filename.split(".").pop();
                    this.sendAgentMediaMessage(res.data.filename,extension);
                }
            }
            catch (error){
                this.isAttachmentDialogHidden = true;
                this.uploadLabel='Send';
                console.log(error);
                alert("error while posting file");
                this.submitLabel="Submit";
            }

        },
        showAttachmentDialog(event){
              this.attachmentDialogLeft = event.clientX+"px";
              this.attachmentDialogTop = (event.clientY-300)+"px";
              console.log(this.attachmentDialogLeft);
              console.log(this.attachmentDialogTop);
              this.isAttachmentDialogHidden = false;
              return false;
          },
        appendMessage(name, img, side, msg) {
        //   Simple solution for small apps
              var messageType = msg.content.type;
              var text = "";
              if(messageType == "text"){
                text = msg.content.text;
              }
              else if(messageType == "image"){
                text = "<img src='"+msg.content.image.url+"'/>"
                if(msg.content.image.caption){
                  text +="<br/>" + msg.content.image.caption;
                }
              }
              else if(messageType == "file"){
                //text = "<iframe src='https://docs.google.com/gview?url="+msg.content.file.url+"&embedded=true'></iframe><br><a href='"+msg.content.file.url+"'>Download</a><br/>";
                text="<a target='_new' href='"+msg.content.file.url+"'>Open PDF <svg class='Vlt-icon' style='width:30px;height:30px;padding:2px'><use xlink:href='#V_Vlt-icon-file-pdf'></use></svg></a><br/>";
                if(msg.content.file.caption){
                  text +="<br/>" + msg.content.file.caption;
                }
              }
              else if(messageType == "audio"){
                text = "<audio controls><source src='"+msg.content.audio.url+"'/></audio>"
                if(msg.content.audio.caption){
                  text +="<br/>" + msg.content.audio.caption;
                }
              }
              else if(messageType == "video"){
                text = "<video style='width:100%' controls><source src='"+msg.content.video.url+"'/></video>"
                if(msg.content.video.caption){
                  text +="<br/>" + msg.content.video.caption;
                }
              }
              if(side=="left"){
                  /*customer message is always on right side */
              }
              else{
                  this.chatContent += `<div style="display: flex;align-items: flex-end;margin-bottom: 10px; flex-direction: row-reverse;color: black;border-bottom-right-radius: 0;">
                    <div style="width: 50px;height: 50px;margin-right: 10px;background: #ddd;background-repeat: no-repeat;background-position: center;background-size: cover;border-radius: 50%;background-image: url(${img}); margin: 0 0 0 10px;"></div>

                    <div style="max-width: 450px;padding: 15px;border-radius: 15px;background: lightgrey;color: black;border-bottom-right-radius: 0;border-bottom-left-radius: 0;">
                      <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 10px;">
                        <div style="margin-right: 10px;font-weight: bold;">${name}</div>
                        <div style="font-size: 0.85em;">${this.formatDate(new Date())}</div>
                      </div>

                      <div class="msg-text">${text}</div>
                    </div>
                  </div>`;
              }
             
        },
        hasExtension(inputID, exts) {
          var fileName = document.getElementById(inputID).value.toLowerCase();;
          return (new RegExp('(' + exts.join('|').replace(/\./g, '\\.') + ')$')).test(fileName);
        },
        appendRawMessage(name, img, side, messageType,url,caption) {
        //   Simple solution for small apps
              var text = "";
              if(messageType == "text"){
                text = caption;
              }
              else if(messageType == "image"){
                if(url=="" && caption.startsWith("data:image")){
                  console.log("showing data image");
                  text += "<img src='"+caption+"'/>"
                }
                else{
                  console.log("showing normal image");
                  text = "<img src='"+url+"'/>";
                  if(caption){
                    text +="<br/>" + caption;
                  }
                }
              }
              else if(messageType == "file"){
                //text = "<iframe src='https://docs.google.com/viewerng/viewer?url="+url+"&embedded=true'></iframe><br><a href='"+msg.content.file.url+"'>Download</a>";
                text="<a target='_new' href='"+url+"'>Open PDF <svg class='Vlt-icon' style='width:30px;height:30px;padding:2px'><use xlink:href='#V_Vlt-icon-file-pdf'></use></svg></a> <br/>";
                if(caption){
                  text +="<br/>" + caption;
                }
              }
              else if(messageType == "audio"){
                text = "<audio controls><source src='"+url+"'/></audio>"
                if(caption){
                  text +="<br/>" + caption;
                }
              }
              else if(messageType == "video"){
                text = "<video style='width:100%' controls><source src='"+url+"'/></video>"
                if(caption){
                  text +="<br/>" + caption;
                }
              }
              if(side == "right"){
                  this.chatContent += `<div style="display: flex;align-items: flex-end;margin-bottom: 10px; flex-direction: row-reverse;color: black;border-bottom-right-radius: 0;">
                    <div style="width: 50px;height: 50px;margin-right: 10px;background: #ddd;background-repeat: no-repeat;background-position: center;background-size: cover;border-radius: 50%;background-image: url(${img}); margin: 0 0 0 10px;"></div>

                    <div style="max-width: 450px;padding: 15px;border-radius: 15px;background: lightgrey;color: black;border-bottom-right-radius: 0;border-bottom-left-radius: 0;">
                      <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 10px;">
                        <div style="margin-right: 10px;font-weight: bold;">${name}</div>
                        <div style="font-size: 0.85em;">${this.formatDate(new Date())}</div>
                      </div>

                      <div class="msg-text">${text}</div>
                    </div>
                  </div>`;
              }
              else{
                  this.chatContent += `<div style="display: flex;align-items: flex-end;margin-bottom: 10px;">
                    <div style="width: 50px;height: 50px;margin-right: 10px;background: #ddd;background-repeat: no-repeat;background-position: center;background-size: cover;border-radius: 50%;background-image: url(${img}); "></div>

                    <div style="max-width: 450px;padding: 15px;border-radius: 15px;background: lightgrey;color: black;border-bottom-right-radius: 0;border-bottom-left-radius: 0;">
                      <div style="display: flex;justify-content: space-between;align-items: center;margin-bottom: 10px;">
                        <div style="margin-right: 10px;font-weight: bold;">${name}</div>
                        <div style="font-size: 0.85em;">${this.formatDate(new Date())}</div>
                      </div>

                      <div class="msg-text">${text}</div>
                    </div>
                  </div>`;
              }
             
        },
        async sendAgentMessage(){
          var msgerInput = document.querySelector(".msger-input");
          const msgText = msgerInput.value;
          if (!msgText) return;
          const BOT_IMG = "https://vids.vonage.com/unifiedAgent/agent.svg";
          var x = await this.appendRawMessage("Agent", BOT_IMG, "left", "text","",msgText);
          msgerInput.value = "";
          var msgerChat = document.querySelector(".msger-chat");
          msgerChat.scrollTop += 500;
          if(this.channel=="whatsapp"){
            this.DEMO.post('unifiedAgent/sendwatext', {
                  to: this.callerName,
                  message: msgText
            });
          }
          else if(this.channel == "inapp-chat"){
            this.sendInAppChat(msgText);
          }
          else if(this.channel =="viber"){
            this.DEMO.post('unifiedAgent/sendvibertext', {
                  to: this.callerName,
                  message: msgText
            });
          }
          return false;
        },
        async sendAgentMediaMessage(file,extension){
          if(this.channel=="whatsapp"){
            /*first find type*/
            var filetype="";
            if(this.waImageFormats.includes(extension)){
              filetype="image";
            }
            else if(this.waVideoFormats.includes(extension)){
              filetype="video";
            }
            else if(this.waFileFormats.includes(extension)){
              filetype="file";
            }
            else if(this.waAudioFormats.includes(extension)){
              filetype="audio"
            }
            else {
              alert("Unsupported file format");
              return;
            }
            var url = this.uploadBaseUrl+file;

            const BOT_IMG = "https://vids.vonage.com/unifiedAgent/agent.svg";
            var x = await this.appendRawMessage("Agent", BOT_IMG, "left", filetype,url,file);
            
            var msgerChat = document.querySelector(".msger-chat");
            msgerChat.scrollTop += 500;

            this.DEMO.post('unifiedAgent/sendwamedia', {
                to: this.callerName,
                type: filetype,
                url: url,
                caption: file
            });

          }
          else if(this.channel=="viber"){
            /*first find type*/
            var filetype="";
            if(this.viberImageFormats.includes(extension)){
              filetype="image";
            }
            else {
              alert("Unsupported file format");
              return;
            }
            var url = this.uploadBaseUrl+file;

            const BOT_IMG = "https://vids.vonage.com/unifiedAgent/agent.svg";
            var x = await this.appendRawMessage("Agent", BOT_IMG, "left", filetype,url,file);
            
            var msgerChat = document.querySelector(".msger-chat");
            msgerChat.scrollTop += 500;

            this.DEMO.post('unifiedAgent/sendvibermedia', {
                to: this.callerName,
                type: filetype,
                url: url
            });

          }

        },
        async sendCustomerMessage(msg){
          const CUSTOMER_IMG = "https://vids.vonage.com/unifiedAgent/customer.svg";
          var x = await this.appendMessage("Customer", CUSTOMER_IMG, "right", msg);
          var msgerChat = document.querySelector(".msger-chat");
          msgerChat.scrollTop += 500;
        },
        formatDate(date) {
          const h = "0" + date.getHours();
          const m = "0" + date.getMinutes();
          return `${h.slice(-2)}:${m.slice(-2)}`;
        },
        sendText() {
            console.log("To " + this.number + " we send: " + this.message);
            this.DEMO.post('smsDemo.php/send', {
                to: this.number,
                message: this.message
            });
            this.$swal('Success',
                'The Text Message has been sent to ' + this.numberStuff.formatInternational + '.',
                'success');
        },
        updateQueue(){
          var queueContent ="";
          console.log(this.queue);
          for(var i=0;i<this.queue.length;i++){
            queueContent += `<div style="width: 98%;margin-top: 3px;height: 50px;background: rgb(252, 252, 253);margin-left: 0.5%;margin-right: 0.5%;box-shadow: 4px 4px #888888;border-radius: 20px 0px 0px 20px" ><table style="width:100%;height:100%">
                <tr>
                  <td style="text-align: left;vertical-align: middle;padding-left:10px;width:30%"><svg style="width:40px;height:40px" class="icon" viewBox="0 0 24 24">
                    <use xlink:href="#icon-`+this.queue[i].channel+`" />
                  </svg></td>
                  <td style="vertical-align: middle;text-align:left"><label style="font-size: 20px"><b>`+this.queue[i].from+`</b></label></td>
                </tr>
              </table></div>`;  
          }
          this.queueItems = queueContent;   
        },
        joinInAppSession(cid){
          var thisconversation = this.inapp.getConversation(cid).then((newconv) => {
            console.log(newconv);
            this.inappchatconv = newconv;
            newconv.join().then((member) => {
                console.log("joined as member: ", member)
                this.sendInAppChat("Agent joined session");
                const CUSTOMER_IMG = "https://vids.vonage.com/unifiedAgent/customer.svg";
                this.appendRawMessage(this.callerName, CUSTOMER_IMG, "right", "text","","Session started");
            }).catch((error) => {
              if(error.type == "conversation:error:member-already-joined"){
                console.log("User is already part of conversation");
                this.sendInAppChat("Agent joined session"); 
                const CUSTOMER_IMG = "https://vids.vonage.com/unifiedAgent/customer.svg";
                this.appendRawMessage(this.callerName, CUSTOMER_IMG, "right", "text","","Session started");                                       
              }
            });
            newconv.on("text",(sender, message) => {
                    console.log(message);
                // Identify your own message.
                    if (message.from !== newconv.me.id){
                  // Identify if the event corresponds to the currently open conversation.
                          if (message.cid === this.inappchatconv.id){
                              const CUSTOMER_IMG = "https://vids.vonage.com/unifiedAgent/customer.svg";
                              this.appendRawMessage(this.callerName, CUSTOMER_IMG, "right", "text","",message.body.text);
                          }
                    }
            });
            newconv.on("image",(sender, image) => {
                console.log("received image");
                console.log(image);
                image.fetchImage().then((imagedata) => {
                   if(image.from !== newconv.me.id){
                      const CUSTOMER_IMG = "https://vids.vonage.com/unifiedAgent/customer.svg";
                      this.appendRawMessage(this.callerName, CUSTOMER_IMG, "right", "image","",imagedata);
                    }
                    else{
                      const BOT_IMG = "https://vids.vonage.com/unifiedAgent/agent.svg";
                      this.appendRawMessage(this.callerName, BOT_IMG, "left", "image","",imagedata);
                    }
                 });
            });
            newconv.on("member:media", (member, event) => {
                console.log(`*** Member changed media state`, member, event)
                this.audioElem = document.getElementById("audio");
                event.conversation.media
                      .enable()
                      .then(stream => {
                        // Older browsers may not have srcObject
                        if ("srcObject" in this.audioElem) {
                          this.audioElem.srcObject = stream;
                        } else {
                          // Avoid using this in new browsers, as it is going away.
                          this.audioElem.src = window.URL.createObjectURL(stream);
                        }

                        this.audioElem.onloadedmetadata = () => {
                          this.audioElem.play();
                        }
                });
            });
          });
        },
        sendInAppChat(msg){
          this.inappchatconv.sendText(msg).then(() => {
              console.log('message '+msg+'  was sent');
            }).catch((error)=>{
              console.log('error sending the message', error);
          });

        },
        displayTimer(){
          this.elapsed_seconds++;
          this.timerValue = this.toHHMMSS(this.elapsed_seconds);
        },
        toHHMMSS(secs){
          var sec_num = parseInt(secs, 10)    
          var hours   = Math.floor(sec_num / 3600) % 24
          var minutes = Math.floor(sec_num / 60) % 60
          var seconds = sec_num % 60    
          return [hours,minutes,seconds]
              .map(v => v < 10 ? "0" + v : v)
              .filter((v,i) => v !== "00" || i > 0)
              .join(":")
        },
        async register() {
            console.log("Registering the Demo Component with the associated backend");
            try{
              const {
                  data
              } = await this.DEMO.post('unifiedAgent/register', {});
              console.log("Got ["+data+"]");
              this.DC = data.DC;
              this.nexmoClient = await new NexmoClient({
                                        nexmo_api_url: "https://api"+this.DC+".nexmo.com",
                                        url: "wss://ws"+this.DC+".nexmo.com"/*,
                                        ips_url: "https://api"+this.DC+".nexmo.com/v1/image",
                                        debug: true*/
                                      })
                          .createSession(data.userJwt)
                          .then(app => this.inapp=app)
                          .catch(err => console.log(err));
              }
            catch(err){
              this.$swal('Error',
                'Coud not register with the backend',
                'error');
              return;
            }
            var self = this;
            console.log("My Id "+this.inapp.me.id);
            this.inapp.on("member:call", (member, call) => {
                self.activeCall = call;
                console.log("logging conversation");
                console.log(call.conversation);
                call.answer();
                self.callAnswered = true;
                self.callState="Connected";
                self.elapsed_seconds=0;
                self.callTimer = setInterval(function(){self.displayTimer()},1000);
                this.activeCall.conversation.on("member:left",(member, event) => {
                  let sendName = member.user ? member.user.name : member.userName;
                  console.log(sendName + " left");
                  console.log(event.body.reason);
                  console.log(member);
                });
            });
            this.inapp.on("call:status:changed",(call) => {
                console.log("Call status change");
                console.log(call);
                if(call.status=="completed"){
                  console.log("call completed");
                  this.hangUpOrRejectCall();
                  clearInterval(self.callTimer);
                  self.timerValue="00:00";
                }
            });
            this.inapp.on("member:joined",(member, event) => {
                    console.log("JOINED", "Joined conversation: " + event.conversation.display_name || event.conversation.name);
                    console.log(member);
                    console.log(event);
                    if(member.callStatus == "answered" && member.channel.to.number == this.supervisorNumber){
                        /* supervisor answered the call */

                    }
            });

            
        },
        onUpdate(payload) {
            this.numberStuff = payload;
            if (payload.isValid) {
                this.number = this.numberStuff.formattedNumber.replace(/\D/g, '');;
            }
        },
        onNewOwnMessage(msg) {
            console.log("Sending type : " + this.selected + " with message: " + msg);
            var chan = "sms";
            if (this.selected == 2) {
                chan = "voice";
            } else if (this.selected == 1) {
                chan = "whatsapp";
            } else if (this.selected == 3) {
                chan = "mms";
            }
            this.NODEDEMO.post('/chatsend', {
                channel: chan,
                text: msg
            });
        },

    },
    components: {
        "vlt-icon": VltIcon,
        "vlt-button": VltButton,
        "vlt-field": VltField,
        "vlt-input": VltInput,
        "vlt-tab":VltTab,
        "vlt-tabs":VltTabs,
    },
    mounted(){
      
    },
    created() {
        var url = $NODEBASE + "/";
        this.DEMO = axios.create({
            baseURL: url,
            headers: {
                'Content-Type': 'application/json'
            }
        })
        console.log("Sending to demo server: "+url);
        this.DEMO.interceptors.request.use(
            request => requestHandler(request)
        )
        this.register();
        this.fromNumber = this.nexmo['from'];
        this.owner = this.nexmo['phone'];
        this.uploadBaseUrl="https://vids.vonage.com/pages/unifiedAgent/"+this.nexmo['phone']+"/";
        this.prettyNumber = parsePhoneNumberFromString("+" +this.nexmo['vfrom']).formatNational();

        let pusher = new Pusher('c9ba403e9b27d7e8e21c', { //Pusher Key
            cluster: 'ap1',
            forceTLS: true
        });
       // console.log("registerd pusher key:"+this.nexmo['pusher_key']);
       
        this.pusherChannel = pusher.subscribe("unifiedAgentDemo");
        this.pusherChannel.bind("waincoming"+this.nexmo.userid, data => {
              console.log(data);
              /* check if this belongs to current active session */
              if(data.from.number == this.callerName && this.channel == "whatsapp"){
                console.log('already active session');
                this.sendCustomerMessage(data.message);
              }
              else{
                if(this.isAgentBusy){
                  console.log('sending to queue');
                  /* agent not available, add to queue */
                  var entry = {};
                  entry.from = data.from.number;
                  entry.channel = "whatsapp";
                  entry.message = data.message;
                  this.queue.push(entry);
                  this.updateQueue();
                }
                else{
                  /* agent available, assign to him */
                  console.log('assigned to a new session');
                  this.isChatWindowHidden =false;
                  this.callerName = data.from.number;
                  this.channel = "whatsapp";
                  this.sendCustomerMessage(data.message);
                  this.isActiveCustomerHidden = false;
                  this.isAgentBusy = true;
                }
              }
        });

        this.pusherChannel.bind("viberincoming"+this.nexmo.userid, data => {
              console.log(data);
              /* check if this belongs to current active session */
              if(data.from.id == this.callerName && this.channel == "viber"){
                console.log('already active session');
                this.sendCustomerMessage(data.message);
              }
              else{
                if(this.isAgentBusy){
                  console.log('sending to queue');
                  /* agent not available, add to queue */
                  var entry = {};
                  entry.from = data.from.id;
                  entry.channel = "viber";
                  entry.message = data.message;
                  this.queue.push(entry);
                  this.updateQueue();
                }
                else{
                  /* agent available, assign to him */
                  console.log('assigned to a new session');
                  this.isChatWindowHidden =false;
                  this.callerName = data.from.id;
                  this.channel = "viber";
                  this.sendCustomerMessage(data.message);
                  this.isActiveCustomerHidden = false;
                  this.isAgentBusy = true;
                }
              }
        });
        this.pusherChannel.bind("inappchatincoming"+this.nexmo.userid, data => {
              console.log(data);
              /* check if this belongs to current active session */
                if(this.isAgentBusy){
                  console.log('sending to queue');
                  /* agent not available, add to queue */
                  var entry = {};
                  entry.from = data.from;
                  entry.channel = "inapp-chat";
                  entry.conversationid = data.conversationid;
                  this.queue.push(entry);
                  this.updateQueue();
                }
                else{
                  /* agent available, assign to him */
                  console.log('assigned to a new session');
                  this.isChatWindowHidden =false;
                  this.callerName = data.from;
                  this.channel = "inapp-chat";
                  this.isActiveCustomerHidden = false;
                  this.isAgentBusy = true;
                  this.joinInAppSession(data.conversationid);
                }
        });

        this.pusherChannel.bind("delivery", data => {
            console.log("Got some delivery data: " +data);
            //this.delivery.unshift(data);
        });
        this.pusherChannel.bind("callincoming"+this.nexmo.userid, data => {
            
            if(this.isAgentBusy){
              console.log('sending to queue');
              /* agent not available, add to queue */
              var entry = {};
              entry.from = data.from;
              entry.channel = "pstn";
              entry.caller_uuid = data.caller_uuid;
              this.queue.push(entry);
              this.updateQueue();
            }
            else{
              /* agent available, assign to him */
              this.isAgentBusy = true;
              console.log('assigned to a new session');
              this.callerName = data.from;
              this.channel = "pstn";
              this.isActiveCustomerHidden = false;
              this.isChatWindowHidden = true;
              this.isCallWindowHidden = false;
              this.caller_uuid = data.caller_uuid;
              this.callState="Ringing";
              this.timerValue="00:00";
              clearInterval(this.callTimer);
            }
            //this.delivery.unshift(data);
        });

        this.pusherChannel.bind("videocallincoming"+this.nexmo.userid, data => {
            console.log(data);
            if(this.isAgentBusy){
              console.log('sending to queue');
              /* agent not available, add to queue */
              var entry = {};
              entry.sessionId = data.sessionId;
              entry.channel = "video";
              entry.token = data.token;
              entry.apiKey = data.apiKey;
              entry.from = data.name;
              this.queue.push(entry);
              this.updateQueue();
            }
            else{
              /* agent available, assign to him */
              console.log('assigned to a new session');
              this.isAgentBusy = true;
              this.callerName = data.name;
              this.channel = "video";
              this.sessionId = data.sessionId;
              this.token = data.token;
              this.apiKey = data.apiKey;
              this.isActiveCustomerHidden = false;
              this.isChatWindowHidden = true;
              this.isCallWindowHidden = true;
              this.isVideoCallHidden = false;
              this.isVideoAcceptBtnHidden = false;
              setTimeout(function(){document.getElementById('subscriber').innerHTML = '<label style="font-size:20px;margin-left:20%;margin-top:150px;position: absolute;">To Accept the Video call, please click on the Phone icon below</label>';},1000);
            }
            //this.delivery.unshift(data);
        });
        console.log(this.nexmo); 
        this.updateQueue();
    },
    beforeDestroy(){
       if(this.session){
            this.session.disconnect();
            this.session = null;
        }
        if(this.nexmoClient){
          this.nexmoClient.logout();
          this.nexmoClient =null;
        }
    },
}
</script>
 <style  scoped>
:root {
  --body-bg: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  --msger-bg: #fff;
  --border: 2px solid #ddd;
  --left-msg-bg: #ececec;
  --right-msg-bg: #579ffb;
}

html {
  box-sizing: border-box;
}

*,
*:before,
*:after {
  margin: 0;
  padding: 0;
  box-sizing: inherit;
}

body {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  background-image: var(--body-bg);
  font-family: Helvetica, sans-serif;
}

.middlearea {
  background-image: linear-gradient(
      rgba(255, 255, 255, 0.7),
      rgba(255, 255, 255, 0.7)
    ),
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:fi='http://pattern.flaticon.com/' x='0' y='0' width='700' height='350' viewBox='0 0 700 350'%3E%3Crect x='0px' y='0px' width='100%25' height='100%25' opacity='1' fill='%23ffffff'/%3E%3Cdefs%3E%3Cpath d='m437 0h-362c-41.351562 0-75 33.648438-75 75v362c0 41.351562 33.648438 75 75 75h151v-181h-60v-90h60v-61c0-49.628906 40.371094-90 90-90h91v90h-91v61h91l-15 90h-76v181h121c41.351562 0 75-33.648438 75-75v-362c0-41.351562-33.648438-75-75-75zm0 0' transform='matrix(0.1171875 0 0 0.1171875 147 227)' id='L1_0'/%3E%3Cpath d='m256 0c-140.609375 0-256 115.390625-256 256 0 46.40625 12.511719 91.582031 36.238281 131.105469l-36.238281 124.894531 124.894531-36.238281c39.523438 23.726562 84.699219 36.238281 131.105469 36.238281 140.609375 0 256-115.390625 256-256s-115.390625-256-256-256zm160.054688 364.167969-11.910157 11.910156c-16.851562 16.851563-55.605469 15.515625-80.507812 10.707031-82.800781-15.992187-179.335938-109.5625-197.953125-190.59375-9.21875-40.140625-4.128906-75.039062 9.183594-88.355468l11.910156-11.910157c6.574218-6.570312 17.253906-6.5625 23.820312 0l47.648438 47.652344c3.179687 3.179687 4.921875 7.394531 4.921875 11.90625s-1.742188 8.730469-4.921875 11.898437l-11.90625 11.921876c-13.125 13.15625-13.125 34.527343 0 47.652343l78.683594 77.648438c13.164062 13.164062 34.46875 13.179687 47.652343 0l11.910157-11.90625c6.148437-6.183594 17.632812-6.203125 23.832031 0l47.636719 47.636719c6.46875 6.441406 6.714843 17.113281 0 23.832031zm0 0' transform='matrix(0.1171875 0 0 0.1171875 317 220)' id='L1_1'/%3E%3Cg transform='matrix(2.5 0 0 2.5 224 140)' id='L1_2'%3E%3Cpath d='m23.155 13.893c.716-6.027-.344-9.832-2.256-11.553l.001-.001c-3.086-2.939-13.508-3.374-17.2.132-1.658 1.715-2.242 4.232-2.306 7.348-.064 3.117-.14 8.956 5.301 10.54h.005l-.005 2.419s-.037.98.589 1.177c.716.232 1.04-.223 3.267-2.883 3.724.323 6.584-.417 6.909-.525.752-.252 5.007-.815 5.695-6.654zm-12.237 5.477s-2.357 2.939-3.09 3.702c-.24.248-.503.225-.499-.267 0-.323.018-4.016.018-4.016-4.613-1.322-4.341-6.294-4.291-8.895.05-2.602.526-4.733 1.93-6.168 3.239-3.037 12.376-2.358 14.704-.17 2.846 2.523 1.833 9.651 1.839 9.894-.585 4.874-4.033 5.183-4.667 5.394-.271.09-2.786.737-5.944.526z'/%3E%3Cpath d='m12.222 4.297c-.385 0-.385.6 0 .605 2.987.023 5.447 2.105 5.474 5.924 0 .403.59.398.585-.005h-.001c-.032-4.115-2.718-6.501-6.058-6.524z'/%3E%3Cpath d='m16.151 10.193c-.009.398.58.417.585.014.049-2.269-1.35-4.138-3.979-4.335-.385-.028-.425.577-.041.605 2.28.173 3.481 1.729 3.435 3.716z'/%3E%3Cpath d='m15.521 12.774c-.494-.286-.997-.108-1.205.173l-.435.563c-.221.286-.634.248-.634.248-3.014-.797-3.82-3.951-3.82-3.951s-.037-.427.239-.656l.544-.45c.272-.216.444-.736.167-1.247-.74-1.337-1.237-1.798-1.49-2.152-.266-.333-.666-.408-1.082-.183h-.009c-.865.506-1.812 1.453-1.509 2.428.517 1.028 1.467 4.305 4.495 6.781 1.423 1.171 3.675 2.371 4.631 2.648l.009.014c.942.314 1.858-.67 2.347-1.561v-.007c.217-.431.145-.839-.172-1.106-.562-.548-1.41-1.153-2.076-1.542z'/%3E%3Cpath d='m13.169 8.104c.961.056 1.427.558 1.477 1.589.018.403.603.375.585-.028-.064-1.346-.766-2.096-2.03-2.166-.385-.023-.421.582-.032.605z'/%3E%3C/g%3E%3Cg transform='matrix(0.1171831488609314 0 0 0.1171831488609314 65 34.999998626759975)' id='L1_3'%3E%3Cpath d='M255.994,42.372c5.88,4.412,11.025,4.89,26.402,5.76c45.056,2.586,73.626,12.211,105.404,35.541 c38.903,28.459,63.309,68.156,72.559,117.99c2.381,12.902,3.558,23.851,4.36,40.354c0.486,11.068,0.87,15.36,3.388,20.207 c3.55,6.613,10.428,11.008,18.406,11.75c0.785,0.068,1.57,0.102,2.347,0.102c7.1,0,13.688-3.004,17.894-8.235 c5.589-6.81,5.581-13.158,5.035-26.829c-1.604-42.342-10.863-80.384-27.52-113.067c-11.878-23.253-23.219-38.485-43.358-58.231 c-21.478-20.881-38.033-32.563-63.309-44.638C350.825,10.295,331.881,6.25,304.139,2.863c-5.598-0.64-16.137-1.476-23.45-1.715 c-13.935-0.461-19.379-0.085-25.813,5.632c-4.932,4.343-7.62,10.94-7.398,18.116C247.699,32.021,250.788,38.361,255.994,42.372z'/%3E%3Cpath d='M396.436,225.422c0,11.989,0.99,23.245,12.808,29.065c3.243,1.681,7.467,2.526,11.588,2.526 c3.661,0,7.228-0.674,9.95-2.039c4.779-2.458,9.6-7.646,11.486-12.339c2.398-6.05,1.306-27.742,0.623-33.86 c-3.2-27.332-12.698-53.137-27.46-74.615c-26.743-38.852-66.816-62.345-119.083-69.828c-17.724-2.611-30.891-3.533-38.639,8.294 c-6.084,8.986-5.308,20.446,1.877,28.476c5.726,6.494,13.926,7.962,21.18,8.542c20.77,1.638,44.032,8.439,59.281,17.323 l0.026,0.008c17.741,10.274,32.427,25.208,42.487,43.196C391.376,185.904,396.436,206.043,396.436,225.422z'/%3E%3Cpath d='M350.977,152.133c-11.674-10.692-25.353-17.391-43.017-21.077c-4.045-0.853-10.906-1.596-15.172-1.835 c-7.356-0.452-10.385-0.375-15.616,2.167c-6.323,3.174-10.752,9.062-12.169,16.137c-1.408,7.031,0.393,14.106,5.001,19.482 c5.325,6.084,10.778,7.603,21.777,8.909c18.381,2.202,28.732,8.388,34.586,20.659c2.961,6.263,4.642,13.124,5.615,22.989 c1.007,9.242,2.816,15.172,9.395,20.036c4.139,3.123,9.378,4.668,14.566,4.668c5.675,0,11.298-1.852,15.403-5.513l0.051-0.034 c8.482-7.671,8.841-17.186,6.545-32.034C374.384,182.904,366.081,166.076,350.977,152.133z'/%3E%3Cpath d='M511.965,413.822c-0.418-9.293-3.61-17.604-9.566-24.781c-5.751-6.784-42.487-35.831-58.88-47.053 c-12.749-8.678-32.896-20.898-42.317-25.668c-13.918-6.921-27.913-8.132-41.685-3.567c-3.012,1.007-5.163,1.903-7.185,2.961 c-6.972,3.661-12.092,9.429-22.042,21.666c-10.658,12.868-12.877,15.369-12.851,15.369c-1.007,0.606-2.611,1.459-4.557,2.347 c-7.927,3.61-20.924,0.64-42.061-9.66c-17.835-8.627-33.852-19.703-51.942-35.9c-15.411-13.73-30.908-31.539-39.509-45.355 c-11.947-19.166-19.174-41.344-19.26-51.644c0-4.011,1.758-9.771,3.661-12.945l0.836-0.862c0.563-0.546,1.186-1.135,2.039-1.886 c2.97-2.671,7.27-6.246,11.75-9.788c19.661-15.488,25.89-21.76,29.218-33.408c3.217-10.769,0.393-24.03-8.892-41.719 c-13.833-26.394-57.694-82.569-75.998-94.413c-3.012-1.886-7.97-4.429-11.477-5.606c-7.509-2.654-18.295-3.558-25.003-2.133 c-9.284,1.903-19.473,7.748-41.958,24.081C31.965,42.878,12.97,60.516,7.815,68.947c-12.16,20.42-9.062,38.135,1.963,67.806 c10.505,28.314,23.979,56.815,39.996,84.642l0.836,1.408c3.226,5.572,6.528,11.128,9.993,16.7l0.896,1.408 c3.439,5.47,6.921,10.931,10.564,16.367l5.743,8.354c2.142,3.123,4.275,6.238,6.485,9.336 c4.361,6.076,8.832,12.134,13.466,18.176c49.399,64.324,106.308,115.968,173.969,157.858l2.773,1.741 c9.822,6.016,20.275,12.032,31.061,17.869l4.215,2.27c11.162,5.939,21.768,11.264,32.427,16.256l3.319,1.51 c12.587,5.828,24.098,10.837,35.174,15.3c13.406,5.41,19.61,7.066,29.03,7.066c1.673,0,3.456-0.051,5.402-0.145 c6.076-0.29,11.537-1.195,16.708-2.773c7.262-2.202,14.532-5.897,22.852-11.64c1.451-0.998,2.901-2.014,4.463-3.166 c1.843-1.357,3.806-3.021,5.794-4.736c9.481-8.201,20.361-20.113,29.124-31.863c4.676-6.272,10.889-15.377,13.986-23.194 c2.901-7.313,4.215-14.609,3.908-21.666V413.822z'/%3E%3C/g%3E%3Cpath d='M55.263,16.429c-1.087-0.695-2.437-0.788-3.608-0.247L44,19.715v-0.131c0-1.823-1.483-3.307-3.307-3.307H36v-5 c0-1.654-1.346-3-3-3H1c-0.552,0-1,0.447-1,1s0.448,1,1,1h32c0.551,0,1,0.448,1,1v5H3.307C1.483,16.278,0,17.761,0,19.584v25.387 c0,1.823,1.483,3.307,3.307,3.307h37.386c1.824,0,3.307-1.483,3.307-3.307v-0.131l7.655,3.533c0.506,0.233,1.045,0.349,1.582,0.349 c0.707,0,1.409-0.2,2.027-0.596C56.351,47.431,57,46.245,57,44.954V19.602C57,18.311,56.351,17.125,55.263,16.429z M42,44.971 c0,0.721-0.586,1.307-1.307,1.307H3.307C2.586,46.278,2,45.692,2,44.971V19.584c0-0.721,0.586-1.307,1.307-1.307h37.386 c0.721,0,1.307,0.586,1.307,1.307v1.054v23.279V44.971z M55,44.954c0,0.614-0.297,1.157-0.814,1.488 c-0.517,0.331-1.133,0.376-1.692,0.115L44,42.638V21.917l8.493-3.919c0.558-0.26,1.175-0.216,1.692,0.115S55,18.988,55,19.602 V44.954z' transform='matrix(1.0603322982788086 0 0 1.0603322982788086 233.7805305090609 -7.219467086343911)' id='L1_4'/%3E%3C/defs%3E%3Cg fi:class='KUsePattern' opacity='0.16'%3E%3Cpattern id='pattern_L1_0' width='350' height='350' patternUnits='userSpaceOnUse'%3E%3Cuse xlink:href='%23L1_0' x='-350' y='-350'/%3E%3Cuse xlink:href='%23L1_0' x='0' y='-350'/%3E%3Cuse xlink:href='%23L1_0' x='350' y='-350'/%3E%3Cuse xlink:href='%23L1_0' x='-350' y='0'/%3E%3Cuse xlink:href='%23L1_0' x='0' y='0'/%3E%3Cuse xlink:href='%23L1_0' x='350' y='0'/%3E%3Cuse xlink:href='%23L1_0' x='-350' y='350'/%3E%3Cuse xlink:href='%23L1_0' x='0' y='350'/%3E%3Cuse xlink:href='%23L1_0' x='350' y='350'/%3E%3C/pattern%3E%3Crect x='0' y='0' width='100%25' height='100%25' fill='url(%23pattern_L1_0)'/%3E%3C/g%3E%3Cg fi:class='KUsePattern' opacity='0.16'%3E%3Cpattern id='pattern_L1_1' width='350' height='350' patternUnits='userSpaceOnUse'%3E%3Cuse xlink:href='%23L1_1' x='-350' y='-350'/%3E%3Cuse xlink:href='%23L1_1' x='0' y='-350'/%3E%3Cuse xlink:href='%23L1_1' x='350' y='-350'/%3E%3Cuse xlink:href='%23L1_1' x='-350' y='0'/%3E%3Cuse xlink:href='%23L1_1' x='0' y='0'/%3E%3Cuse xlink:href='%23L1_1' x='350' y='0'/%3E%3Cuse xlink:href='%23L1_1' x='-350' y='350'/%3E%3Cuse xlink:href='%23L1_1' x='0' y='350'/%3E%3Cuse xlink:href='%23L1_1' x='350' y='350'/%3E%3C/pattern%3E%3Crect x='0' y='0' width='100%25' height='100%25' fill='url(%23pattern_L1_1)'/%3E%3C/g%3E%3Cg fi:class='KUsePattern' opacity='0.14'%3E%3Cpattern id='pattern_L1_2' width='350' height='350' patternUnits='userSpaceOnUse'%3E%3Cuse xlink:href='%23L1_2' x='-350' y='-350'/%3E%3Cuse xlink:href='%23L1_2' x='0' y='-350'/%3E%3Cuse xlink:href='%23L1_2' x='350' y='-350'/%3E%3Cuse xlink:href='%23L1_2' x='-350' y='0'/%3E%3Cuse xlink:href='%23L1_2' x='0' y='0'/%3E%3Cuse xlink:href='%23L1_2' x='350' y='0'/%3E%3Cuse xlink:href='%23L1_2' x='-350' y='350'/%3E%3Cuse xlink:href='%23L1_2' x='0' y='350'/%3E%3Cuse xlink:href='%23L1_2' x='350' y='350'/%3E%3C/pattern%3E%3Crect x='0' y='0' width='100%25' height='100%25' fill='url(%23pattern_L1_2)'/%3E%3C/g%3E%3Cg fi:class='KUsePattern' opacity='0.13'%3E%3Cpattern id='pattern_L1_3' width='350' height='350' patternUnits='userSpaceOnUse'%3E%3Cuse xlink:href='%23L1_3' x='-350' y='-350'/%3E%3Cuse xlink:href='%23L1_3' x='0' y='-350'/%3E%3Cuse xlink:href='%23L1_3' x='350' y='-350'/%3E%3Cuse xlink:href='%23L1_3' x='-350' y='0'/%3E%3Cuse xlink:href='%23L1_3' x='0' y='0'/%3E%3Cuse xlink:href='%23L1_3' x='350' y='0'/%3E%3Cuse xlink:href='%23L1_3' x='-350' y='350'/%3E%3Cuse xlink:href='%23L1_3' x='0' y='350'/%3E%3Cuse xlink:href='%23L1_3' x='350' y='350'/%3E%3C/pattern%3E%3Crect x='0' y='0' width='100%25' height='100%25' fill='url(%23pattern_L1_3)'/%3E%3C/g%3E%3Cg fi:class='KUsePattern' opacity='0.28'%3E%3Cpattern id='pattern_L1_4' width='350' height='350' patternUnits='userSpaceOnUse'%3E%3Cuse xlink:href='%23L1_4' x='-350' y='-350'/%3E%3Cuse xlink:href='%23L1_4' x='0' y='-350'/%3E%3Cuse xlink:href='%23L1_4' x='350' y='-350'/%3E%3Cuse xlink:href='%23L1_4' x='-350' y='0'/%3E%3Cuse xlink:href='%23L1_4' x='0' y='0'/%3E%3Cuse xlink:href='%23L1_4' x='350' y='0'/%3E%3Cuse xlink:href='%23L1_4' x='-350' y='350'/%3E%3Cuse xlink:href='%23L1_4' x='0' y='350'/%3E%3Cuse xlink:href='%23L1_4' x='350' y='350'/%3E%3C/pattern%3E%3Crect x='0' y='0' width='100%25' height='100%25' fill='url(%23pattern_L1_4)'/%3E%3C/g%3E%3C/svg%3E");
}
.msger {
  display: flex;
  flex-flow: column wrap;
  justify-content: space-between;
  width: 98%;
  max-width: 867px;
  margin: 1% 1%;
  height: 80vh;
  border: solid black 1px;
  border-radius: 5px;
  background: var(--msger-bg);
  box-shadow: 0 15px 15px -5px rgba(0, 0, 0, 0.2);
}

.msger-header {
  text-align: right;
  padding: 10px;
  background: black;
  color: white;
}

.msger-chat {
  flex: 1;
  overflow-y: auto;
  padding: 10px;
}
.msger-chat::-webkit-scrollbar {
  width: 6px;
}
.msger-chat::-webkit-scrollbar-track {
  background: #ddd;
}
.msger-chat::-webkit-scrollbar-thumb {
  background: #bdbdbd;
}
.msg_mc {
  display: flex;
  align-items: flex-end;
  margin-bottom: 10px;
}
.msg_uc:last-of-type {
  margin: 0;
}
.msg-img_uc {
  width: 50px;
  height: 50px;
  margin-right: 10px;
  background: #ddd;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 50%;
}
.msg-bubble_uc {
  max-width: 450px;
  padding: 15px;
  border-radius: 15px;
  background: lightgrey;
}
.msg-info_uc {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
}
.msg-info-name_uc {
  margin-right: 10px;
  font-weight: bold;
}
.msg-info-time_uc {
  font-size: 0.85em;
}

.left-msg_uc .msg-bubble_uc {
  border-bottom-left-radius: 0;
}

.right-msg_uc {
  flex-direction: row-reverse;
}
.right-msg_uc .msg-bubble_uc {
  background: lightgrey;
  color: black;
  border-bottom-right-radius: 0;
}
.right-msg_uc .msg-img_uc {
  margin: 0 0 0 10px;
}

.msger-inputarea {
  display: flex;
  padding: 10px;
  border-top: var(--border);
  background: #eee;
}
.msger-inputarea * {
  padding: 10px;
  border: none;
  border-radius: 3px;
  font-size: 1em;
}
.msger-input {
  flex: 1;
  background: #ddd;
}
.msger-send-btn {
  margin-left: 10px;
  background: #871fff;
  color: #fff;
  font-weight: bold;
  cursor: pointer;
  transition: background 0.23s;
}
.msger-send-btn:hover {
  background: rgb(0, 180, 50);
}

.msger-chat {
  background-color: #fcfcfe;
}
</style>
